import main from './main';
import operations from './operations';
import inventbill from './inventbill';
import settings from './settings';
import { NavItemType } from 'types';

const menuItems: { items: NavItemType[] } = {
  items: [main, operations, inventbill, settings]
};

export default menuItems;
